import store from '@/store'

/**
 * 判定是否拥有功能点
 * @param perms 功能点
 * @param matchAll 匹配所有
 * @returns {boolean}
 */
export function hasPermission(perms, matchAll) {
  // 用户功能点
  let permissions = _.get(store.state.user, 'permissions', [])
  if (_.isArray(perms)) {
    return matchAll ? _.every(perms, o => _.includes(permissions, o))
      : _.findIndex(permissions, o => _.includes(perms, o)) > -1
  } else {
    return _.includes(permissions, perms)
  }
}

/**
 * 判定是否拥有角色
 * @param role
 * @param matchAll
 */
export function hasRole(role, matchAll) {
  // 用户角色
  let roles = store.getters.getCurrentRoles || []
  if (_.isArray(role)) {
    return matchAll ? _.every(role, o => _.includes(roles, o))
      : _.findIndex(roles, o => _.includes(role, o)) > -1
  } else {
    return _.includes(roles, role)
  }
}

/**
 * 获取token头
 * @returns {{token: string}}
 */
export function getTokenHeader() {
  return { token: sessionStorage.getItem('token') }
}

export default {
  install: function (Vue) {
    Vue.prototype.hasPermission = hasPermission
    Vue.prototype.hasRole = hasRole
    Vue.prototype.getTokenHeader = getTokenHeader
  }
}



// WEBPACK FOOTER //
// ./src/utils/authc.js